import { render, staticRenderFns } from "./Main_new.vue?vue&type=template&id=113c9a68"
import script from "./Main_new.vue?vue&type=script&lang=js"
export * from "./Main_new.vue?vue&type=script&lang=js"
import style0 from "./Main_new.vue?vue&type=style&index=0&id=113c9a68&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports